import { db } from 'Compass/profile-lab/services/db';
import { Photo } from 'Compass/profile-lab/types';
import { listAssets } from 'Compass/profile-lab/services/ProfileLabService';

class SyncService {
  async loadUserData(userLid: string): Promise<void> {
    try {
      const photos: Photo[] = await listAssets(parseInt(userLid, 10));

      await db.clearPhotos();
      await db.addPhotosBulk(photos);

      await db.setSyncMetadata(Date.now());
    } catch (error) {
      console.error('Load user data failed:', error);
      throw error;
    }
  }
}

export const syncService = new SyncService();
